import { adobeModalTrackEvent } from '../common/AdobeTagging/adobeModalTrackEvent';
import { Constants } from '../common/Constants';
import { getRoute } from './map.utils';

export const handleMapClickLocation = async (
  map,
  selectedId,
  longitude,
  latitude,
  locationId,
  locationLng,
  locationLat,
  mapOnPremKey,
  mapOnPremURL,
  mobileScreen,
  setDirections,
  setRouteEndCoords,
  setSelectedId,
  getUserLocation,
  expandedListView = false
) => {
  if (selectedId === locationId && !mobileScreen) {
    return;
  }

  const routeDirections = await getRoute(
    map,
    longitude,
    latitude,
    +locationLng,
    +locationLat,
    getUserLocation,
    false,
    'driving-traffic',
    0,
    mapOnPremKey,
    mapOnPremURL
  );

  if (routeDirections) {
    setDirections(routeDirections);
  }

  setRouteEndCoords([locationLng, locationLat]);
  setSelectedId(locationId);

  if (expandedListView) {
    adobeModalTrackEvent(Constants.LIST_VIEW_NAVIGATION_MODAL);
  } else adobeModalTrackEvent(Constants.MAP_VIEW_NAVIGATION_MODAL);
};
